module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_goal-b23c2d8019aecf81aa3e7612a1bc5dc8.svg";